import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const COOKIE_KEY = "chiara_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const setConsent = (value) => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ value, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 right-4 left-4 sm:left-auto sm:right-6 sm:bottom-6 z-[55] sm:max-w-md bg-[#F6F8F3] border border-[#CFD9C5] rounded-3xl shadow-[0_20px_60px_rgba(61,59,58,0.18)] p-6 sm:p-7"
    >
      <p className="eyebrow">Cookie</p>
      <h3 className="font-serif-elegant text-xl mt-2 text-[#3D3B3A] leading-snug">
        Rispetto della tua privacy.
      </h3>
      <p className="mt-3 text-sm text-[#73706E] leading-relaxed">
        Questo sito utilizza esclusivamente <strong>cookie tecnici necessari</strong> al
        funzionamento. Non sono presenti cookie di profilazione né di terze parti.
        Maggiori dettagli nella{" "}
        <Link to="/cookie-policy" className="text-[#7E9C7B] underline">Cookie Policy</Link>{" "}
        e nella{" "}
        <Link to="/privacy" className="text-[#7E9C7B] underline">Privacy Policy</Link>.
      </p>
      <div className="mt-5 flex flex-wrap gap-3">
        <button
          onClick={() => setConsent("accepted")}
          data-testid="cookie-accept"
          className="bg-[#9DB39A] text-white hover:bg-[#7E9C7B] rounded-full px-6 py-2.5 text-sm transition-all"
        >
          Ho capito
        </button>
        <Link
          to="/cookie-policy"
          data-testid="cookie-learn-more"
          className="inline-flex items-center text-sm text-[#73706E] hover:text-[#3D3B3A] border-b border-[#73706E] pb-0.5"
        >
          Scopri di più
        </Link>
      </div>
    </div>
  );
}
